import { Card, CardContent, Divider, Grid, styled, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import ProgressiveImg from "../../app/components/ProgressiveImg";
import { Book } from "../../app/models/book";
import placeholderSrc from "../../images/loading.gif";


interface Props {
  book: Book;
}

const StyledCard = styled(Card)`
  ${({ theme }) => `
  cursor: pointer;
  transition: ${theme.transitions.create(['transform'], {
  duration: theme.transitions.duration.standard,
})};
  &:hover {
    transform: scale(1.05);
  }
  `}
`;
const StyledImgWrapper = styled('div')`
  width: 100%;

  img {
    width: 100%;
    height: 250px;
    object-fit: cover;

    @media (max-width: 640px) {
      height: auto;
    }
  }
`;
const BookCard: React.FC<Props> = ({ book }) => {
  return (
    <Grid container flexDirection="column" alignItems="center">
    <StyledCard sx={{ maxWidth: 250, border: 0, boxShadow: 0 }} >
      <Link to={`/book/${book.id}`} style={{ textDecoration: 'none' }}>
          <StyledImgWrapper>
        <ProgressiveImg
          src={book.coverDisplayLink}
          placeholderSrc={placeholderSrc}
          loading="lazy"
        />
        </StyledImgWrapper>
        <CardContent
          sx={{
            display: 'grid',
            justifyContent: 'center',
            padding: { xs: '10px', sm: '16px' },
          }}
        >
          <Typography variant="subtitle1" component="div" sx={{ textDecoration: 'none', color: '#369aac', fontWeight: '500', lineHeight: {xs: 1.2, sm: 1.75},  fontSize: { xs: '0.8rem', sm: '1rem'} }}>
            {book.title}
          </Typography>
          {book.subTitle !== '' && <Typography variant='body2' component="div" sx={{ textDecoration: 'none', color: '#606060',    fontSize: { xs: '0.7rem', sm: '0.875rem'} }}>{book.subTitle}</Typography>}
          <Typography variant="subtitle2" component="div" sx={{ textDecoration: 'none', color: '#606060', fontSize: { xs: '0.7rem', sm: '0.875rem' } }}>
            by {book.contributors.length > 0 ? book.contributors[0].name : ''}
          </Typography>
          <Divider sx={{ mt: 1, borderColor: '#FFBD59'}} />
          <Typography variant="caption" component="div" sx={{ textDecoration: 'none', color: '#606060', alignSelf: 'flex-end'}}>
            {book.genre}
          </Typography>
        </CardContent>
      </Link>
    </StyledCard>
    </Grid>
  )
}

export default BookCard;
